module.exports = {
    data() {
        return {
            top: false
        }
    },
    props: {
        filter: String,
        showFilter: Boolean,
        footer: String,
        invertOnFooter: Boolean
    },
    methods: {
        toFilter: function () {
            console.log(this.filter);
            console.log(document.querySelector(this.filter));
            console.log(document.querySelector(this.filter).getBoundingClientRect());
            console.log(document.body.scrollTop);
            this.scrollTo(15, document.querySelector(this.filter).getBoundingClientRect().top + document.body.scrollTop - 100);
        },
        toTop: function () {
            this.scrollTo(15, 0);
        },
        scrollTo: function (step, to) {
            var start = window.pageYOffset;
            var count = 0;
            var curOffsetLowerLogic = start < to ? false : true;
            var intervalRef = setInterval((function (interval, curOffset) {
                return function () {
                    if ( !curOffsetLowerLogic ) {
                        curOffset += (interval * step);
                        if (curOffset > to) {
                            curOffset = to;
                        }
                    } else {
                        curOffset -= (interval * step);
                    }
                    console.info("offset = " + curOffset);
                    window.scrollTo(0, curOffset);
                    console.info("pageYoffset = " + window.pageYOffset);
                    count++;
                    if (count > 150 || (curOffsetLowerLogic && curOffset < to) || (!curOffsetLowerLogic && curOffset >= to) ) clearInterval(intervalRef);
                }
            })(step, start--), 50);
        }
    },
    mounted() {
        var
            self = this,
            footerInitialOffset = document.querySelector(this.footer).getBoundingClientRect().top + document.body.scrollTop,
            footerOffset,
            footerInitialInViewPort = false,
            footerInitialOffsetCorrected = false,
            footerInViewPort = false
            ;
        console.log('ScrollTop mounted');
        window.setInterval(function () {
            if (window.scrollY < 100) {
                self.top = false;
            } else {
                self.top = true;
            }

            var height = "innerHeight" in window
                ? window.innerHeight
                : document.documentElement.offsetHeight;

            if (self.invertOnFooter) {
                if ( !footerInitialOffsetCorrected ) {
                    footerOffset = document.querySelector(self.footer).getBoundingClientRect().top + document.body.scrollTop;

                    if (footerInitialOffset > footerOffset) {
                        footerInitialOffset = footerOffset;

                        footerInitialOffsetCorrected = true;
                    }
                }

                if ( window.scrollY + height > footerInitialOffset) {
                    footerOffset = document.querySelector(self.footer).getBoundingClientRect().top + document.body.scrollTop;

                    footerInitialInViewPort = true;
                } else {
                    footerInitialInViewPort = false;
                }

                if (footerInitialInViewPort && window.scrollY + height >= footerOffset) {
                    if (!footerInViewPort) {
                        self.$el.classList.remove('basic');
                        self.$el.classList.remove('black');
                        self.$el.classList.add('white');
                    }
                    footerInViewPort = true;
                } else {
                    if (footerInViewPort) {
                        self.$el.classList.remove('white');
                        self.$el.classList.add('black');
                        self.$el.classList.add('basic');
                    }
                    footerInViewPort = false;
                }
            }
        }, 2000);
    }
}


// WEBPACK FOOTER //
// ./assets/vue/components/scrolltop/scrolltop.js